(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rs-kit-badge')) {
    customElements.define(
      'rs-kit-badge',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.placed) return;
          const holder = this.closest('.product-information__media') || this.parentElement;
          const place = () => {
            const slide = holder?.querySelector('media-gallery slideshow-slide, media-gallery .product-media-container');
            if (!slide || slide.querySelector(':scope > rs-kit-badge')) return;
            const badge = this.cloneNode(true);
            badge.dataset.placed = 'true';
            badge.hidden = false;
            slide.append(badge);
          };
          place();
          this.observer = new MutationObserver(place);
          if (holder) this.observer.observe(holder, { childList: true, subtree: true });
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rs-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rs-delivery')) {
    customElements.define(
      'rs-delivery',
      class extends HTMLElement {
        connectedCallback() {
          const addBusinessDays = (start, days) => {
            const date = new Date(start);
            let added = 0;
            while (added < days) {
              date.setDate(date.getDate() + 1);
              const weekday = date.getDay();
              if (weekday !== 0 && weekday !== 6) added += 1;
            }
            return date;
          };

          const now = new Date();
          const min = addBusinessDays(now, Number(this.dataset.min) || 5);
          const max = addBusinessDays(now, Number(this.dataset.max) || 7);
          const format = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
          const text = this.querySelector('[ref="text"]');
          if (!text) return;

          text.textContent = `${this.dataset.lead || 'Order today, arrives'} `;
          const dates = document.createElement('b');
          dates.textContent = `${format.format(min)} – ${format.format(max)}`;
          text.append(dates);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rs-season-text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rs-season-text')) {
    customElements.define(
      'rs-season-text',
      class extends HTMLElement {
        connectedCallback() {
          this.render = () => {
            const sale = window.rsCurrentSale;
            if (!sale || !sale.title || !this.dataset.template) return;
            const name = [sale.icon, sale.title].filter(Boolean).join(' ');
            this.textContent = this.dataset.template.replace('[sale]', name);
          };
          this.render();
          document.addEventListener('rs:sale', this.render);
        }

        disconnectedCallback() {
          document.removeEventListener('rs:sale', this.render);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
